import React from 'react';
import { ROAST_LAB_CONTENT } from './content';

interface RoastLabHeroV2Props { isZh: boolean }

const RoastLabHeroV2: React.FC<RoastLabHeroV2Props> = ({ isZh }) => {
  const { hero } = ROAST_LAB_CONTENT;
  return (
    <section className="relative w-full overflow-hidden bg-black" style={{ minHeight: '70vh', height: '70vh' }}>
      <img src={hero.image} alt={isZh ? hero.title.zh : hero.title.en} className="absolute inset-0 w-full h-full object-cover opacity-65" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-black/30" />
      <div className="relative z-10 max-w-[1600px] mx-auto h-full px-6 lg:px-12 flex items-end pb-16">
        <h1
          className="text-white tracking-wide leading-[0.95]"
          style={{ fontFamily: '"EB Garamond","Noto Serif TC",serif', fontWeight: 400, fontSize: 'clamp(60px, 10vw, 148px)' }}
        >
          {isZh ? hero.title.zh : hero.title.en}
        </h1>
      </div>
    </section>
  );
};

export default RoastLabHeroV2;
